// IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования)
// Атрибут колонки relation_row — ссылка из ячейки на СТРОКУ табличной части другой записи (у строки своего id нет). Контракт — BE
// addons/ADDON_scm_core/config_responsible_register.STEP_LINK (PR #618), эталон сопоставления — common_modules/responsible_register.approval_step_ref:
//   { segment, id_binding, path: [name вкладки-панели, name вкладки, name грида], grid_binding, match: [{field, binding}], when: {binding, in: []}, open_row }
// Здесь — чистая часть (без Vue / store): условие when по записи строки, id записи по id_binding, выбор правила match (ПЕРВОЕ непустое значение решает:
// не найдено по нему — строки нет, следующее правило не пробуется), индекс строки таблицы. Крючки: AttrGrid.vue (onButtonOpen__Click → relationRow_open:
// «→» формы ячейки и Alt+клик; кнопка «→» формы ячейки у колонки с relation_row), mainStore.set_activeAttr (row_match → rowIndex, open_row → карточка строки).
// Выключатель fe.ux.relationRow (дефолт ВКЛ; false — прежнее поведение: «→» / Alt+клик открывают карточку той же строки). Тест — tests/unit/relationRow.test.mjs
export const RELATION_ROW_FLAG = 'fe.ux.relationRow'
export const RELATION_ROW_ANY = '*'

export function relationRow_flagOn(setting) {
    try { return typeof setting === 'function' ? setting(RELATION_ROW_FLAG, true) !== false : true } catch (e) { return true }
}

// как _s на BE: None → '', иначе строка без краевых пробелов (order 2 == '2')
export function relationRow_s(v) {
    return v === null || v === undefined ? '' : String(v).trim()
}

// значение по точечному binding ('doc.scope_step'); get — store.get_value, если передан (он же понимает особые binding грида)
export function relationRow_get(obj, binding, get = null) {
    if (typeof get === 'function') { try { return get(obj, binding) } catch (e) { return undefined } }
    let cur = obj
    for (const p of String(binding || '').split('.')) {
        if (!p) continue
        if (!cur || typeof cur !== 'object') return undefined
        cur = cur[p]
    }
    return cur
}

// атрибут годен: объект с segment, id_binding и непустым path
export function relationRow_valid(rr) {
    return !!(rr && typeof rr === 'object' && rr.segment && rr.id_binding && Array.isArray(rr.path) && rr.path.length)
}

// условие when: нет условия — действует; иначе значение binding записи строки ∈ in
export function relationRow_when(rr, rec, get = null) {
    const w = rr?.when
    if (!w || !w.binding) return true
    const v = relationRow_s(relationRow_get(rec, w.binding, get))
    return (Array.isArray(w.in) ? w.in : []).some(x => relationRow_s(x) === v)
}

// правило поиска строки: первое правило match, у которого значение binding записи непусто и не '*' → { field, value }; все пусты — null
export function relationRow_match(rr, rec, get = null) {
    for (const m of (Array.isArray(rr?.match) ? rr.match : [])) {
        if (!m || !m.field || !m.binding) continue
        const v = relationRow_get(rec, m.binding, get)
        if (v === null || v === undefined || relationRow_s(v) === '' || relationRow_s(v) === RELATION_ROW_ANY) continue
        return { field: m.field, value: v }
    }
    return null
}

// цель перехода по записи строки rec: null — ссылка не действует (выключена, не та строка по when, нет id) → прежнее поведение
export function relationRow_target(rr, rec, get = null) {
    if (!relationRow_valid(rr) || !rec) return null
    if (!relationRow_when(rr, rec, get)) return null
    const id = relationRow_get(rec, rr.id_binding, get)
    if (relationRow_s(id) === '') return null
    const path = rr.path.map(String)
    return {
        id, segment: rr.segment, path, binding: path[path.length - 1],
        grid_binding: rr.grid_binding || '', row_match: relationRow_match(rr, rec, get), open_row: !!rr.open_row,
    }
}

// activeAttr для parentAction открываемой записи (контракт mainStore.set_activeAttr)
export function relationRow_activeAttr(target) {
    if (!target) return null
    const a = { binding: target.binding, path: target.path.slice() }
    if (target.row_match) a.row_match = { ...target.row_match }
    if (target.grid_binding) a.grid_binding = target.grid_binding
    if (target.open_row) a.open_row = true
    return a
}

// индекс первой строки rows, у которой String(row[field]) === String(value); нет — -1 (rowOf — достать данные строки, напр. flex row → dataItem)
export function relationRow_rowIndex(rows, row_match, rowOf = null) {
    if (!Array.isArray(rows) || !row_match || !row_match.field) return -1
    const want = relationRow_s(row_match.value)
    for (let i = 0; i < rows.length; i++) {
        const r = typeof rowOf === 'function' ? rowOf(rows[i]) : rows[i]
        if (r && typeof r === 'object' && relationRow_s(r[row_match.field]) === want) return i
    }
    return -1
}

// переменные подсказки по Alt у «→»: куда ведёт ссылка
export function relationRow_helpVars(target) {
    if (!target) return {}
    return {
        segment: String(target.segment || ''), id: relationRow_s(target.id),
        path: target.path.join(' → '), table: String(target.grid_binding || target.binding || ''),
        row: target.row_match ? `${target.row_match.field} = ${relationRow_s(target.row_match.value)}` : '—',
    }
}
